<template>
  <div id="app" class="container-fluid">
    <div class="col-12">
      <h2>{{ title }} Report Generator</h2>
      <br>
    </div>
    <Map/>
    <!-- <SampleBlob/> -->
  </div>
</template>

<script>
import {documentReportConfig} from "../config"
import Map from './components/Map.vue'
import SampleBlob from './components/SampleBlob.vue'

export default {
  name: 'app',
  components: {
    Map,
    SampleBlob
  },
  data() {
    return {
      title: documentReportConfig.docTitle
    }
  }
}
</script>

<style>
#app {
  font-family: "Montserrat";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
